import { render, staticRenderFns } from "./board_blank_state.vue?vue&type=template&id=0df442f8"
import script from "./board_blank_state.vue?vue&type=script&lang=js"
export * from "./board_blank_state.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports